import { fromPromise } from 'xstate';
import { useRouter } from 'next/router';
import { type ReactNode } from 'react';
import { useNavigationContext } from '../../../../components/OnboardingNavigation/NavigationProvider';
import { createActorContextWithUseActor } from '../../../../utils/xstate/createActorContextWithUseActor';
import { type FlowMachineInput, type FlowContext as FlowMachineContext, flowMachine } from './flow-machine';
import { getStepPath } from './utils';
export const FlowContext = createActorContextWithUseActor(flowMachine);
export const FlowProvider = ({
  children,
  customContext
}: {
  children: ReactNode;
  customContext?: FlowMachineInput;
}) => {
  const {
    onBackNavigation,
    onForwardNavigation
  } = useNavigationContext();
  const router = useRouter();
  const machineWithConfig = flowMachine.provide({
    actors: {
      handleFlowNavigation: fromPromise(async ({
        input
      }: {
        input: {
          context: FlowMachineContext;
          event: {
            type: string;
          };
        };
      }) => {
        const {
          context,
          event
        } = input;
        const {
          previousStepPath,
          nextStepPath
        } = context;
        if (event.type === 'BACK' && previousStepPath) {
          onBackNavigation();
          router.push(previousStepPath, undefined, {
            shallow: true
          });
        }
        if (event.type === 'NEXT' && nextStepPath) {
          onForwardNavigation();
          router.push(nextStepPath, undefined, {
            shallow: true
          });
        }
        if (event.type === 'PAYMENT_ERROR_REDIRECT') {
          const path = getStepPath({
            ...context,
            identifier: 'payment'
          });
          onBackNavigation();

          // Do a router.replace instead of push to avoid finalize as a new entry in the history stack
          // Await for the replace to complete to prevent the machine from eagerly triggering the UPDATE_FLOW_STEPS event
          await router.replace(path, undefined, {
            shallow: true
          });
        }
        if (event.type === 'SET_ANCHOR_FIX_OUT_OF_STOCK') {
          const path = getStepPath({
            ...context,
            identifier: 'payment'
          });
          onBackNavigation();
          await router.replace(path, undefined, {
            shallow: true
          });
        }
        return event.type;
      })
    }
  });
  return <FlowContext.Provider logic={machineWithConfig} options={{
    input: customContext
  }}>
      {children}
    </FlowContext.Provider>;
};